import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import ICDForm from '../components/ICDForm';
import {
  requestIcd,
  updateIcd,
} from '../../../store/icd-lookup/IcdLookupActions';
import { hostTitle } from '../../../config/ui';

class ICDEdit extends React.Component {
  componentWillMount() {
    this.props.getIcd(this.props.params.key, {
      tenantId: this.props.tenantId,
    });
  }

  onSubmit = (values) => {
    this.props
      .updateIcd(values, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('ICD has been saved.');
          hashHistory.push('/icd-lookup/');
        }
      });
  };

  onCancel = () => {
    hashHistory.push('/icd-lookup/');
  };

  render() {
    const {
      data: { icd },
    } = this.props;

    return (
      <div id="content">
        {icd.key && <Helmet title={`${icd.key} – ${hostTitle()}`} />}
        <BigBreadcrumbs
          items={[
            'Resource Library',
            { title: 'ICD Lookup', route: '/icd-lookup' },
            'ICD',
          ]}
          icon="fa fa-fw fa-book"
          className=""
        />

        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>Edit ICD {icd.key && <i>({icd.key})</i>}</h2>
            </header>
            <div>
              <div className="widget-body">
                {<ICDForm onSubmit={this.onSubmit} onCancel={this.onCancel} />}
              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.icdlookup,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getIcd: (key, params) => dispatch(requestIcd(key, params)),
    updateIcd: (icd, params) => dispatch(updateIcd(icd, params)),
  }),
)(ICDEdit);



// WEBPACK FOOTER //
// ./src/routes/resource-library/containers/ICDEdit.js